import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import PasswordMask from 'react-password-mask';
import qs from 'qs';
import { configureForm } from '@thinkmill/pragmatic-forms';

import { Link } from 'inside-out/components/shared/link';
import { AuthManager } from 'inside-out/managers/authManager';
import { HeaderManager } from 'inside-out/managers/headerManager';
import { navigateTo } from 'inside-out/components/shared/link';

import {
	wrapperStyle,
	innerWrapperStyle,
	titleStyle,
	formBottomStyle,
	checkboxWrapStyle,
} from 'inside-out/page-styles/log-in';

import { formSection } from 'inside-out/global-styles';

const LoginForm = configureForm({
	initFields: ({ redirect }) => ({
		email: '',
		password: '',
		rememberMe: false,
		redirect,
	}),
	validate: ({ email, password }) => {
		const errors = {};
		if (!email) errors.email = 'Please enter an Email Address';
		if (!password) errors.password = 'Please enter a password';
		return errors;
	},
	submit: async formData => {
		try {
			await AuthManager.sharedInstance.logIn(formData);

			if (formData.redirect) {
				// Note for future, navigateTo will only navigate to URLs on the site,
				// so it's not a security risk that will allow random other sites on the
				// login page redirect.
				navigateTo(formData.redirect);
			} else {
				navigateTo('/my-account');
			}
		} catch (e) {
			if (e.networkError) {
				throw "Can't connect to Inside Out. Please check your network connection and try again.";
			} else if (e.graphQLErrors) {
				throw 'Invalid username or password. Please try again.';
			} else {
				console.log('Log in error: ', e);
				throw 'Unknown error. Please try again later.';
			}
		}
	},
})(({ form }) => (
	<form.Form>
		<div>
			<div aria-live="assertive">
				{/* Errors that come back from the server */}
				{form.submitError && (
					<p className={formSection.validationMessage}>Error: {form.submitError}</p>
				)}
				{/* Field Validation Errors */}
				{form.hasErrors && (
					<ul className={formSection.validationSummary}>
						{Object.keys(form.errors).map(key => (
							<li key={key} className={formSection.validationMessage}>{`${form.errors[key]}`}</li>
						))}
					</ul>
				)}
			</div>

			<div className={formSection.field}>
				{form.errors['email'] && (
					<p className={formSection.validationFieldMessage}>{form.errors['email']}</p>
				)}
				<label htmlFor="emailAddress">Email Address</label>
				<input id="emailAddress" {...form.getInputProps({ name: 'email', type: 'text' })} />
			</div>

			<div className={formSection.field}>
				{form.errors['password'] && (
					<p className={formSection.validationFieldMessage}>{form.errors['password']}</p>
				)}
				<label htmlFor="password">Password</label>
				<PasswordMask
					useVendorStyles={false}
					id="password"
					{...form.getInputProps({ name: 'password', type: 'password' })}
				/>
			</div>
			<div className={formBottomStyle}>
				<div className={checkboxWrapStyle}>
					<label>
						<input
							className={formSection.checkbox}
							id="rememberMe"
							{...form.getInputProps({ name: 'rememberMe', type: 'checkbox' })}
						/>
						<span>Remember me</span>
					</label>
				</div>
				<div>
					<Link to="/forgot-password">Forgot password?</Link>
				</div>
			</div>
			<button
				className={formSection.submitButton}
				type="submit"
				disabled={form.hasErrors || form.isLoading}
			>
				Log in
			</button>
		</div>
	</form.Form>
));

export default class LoginPage extends React.PureComponent {
	static propTypes = {
		location: PropTypes.shape({
			search: PropTypes.string,
		}),
	};

	componentDidMount = () => {
		const { location } = this.props;

		HeaderManager.headerProperties = {
			cta: {
				question: 'No account?',
				callToAction: {
					to: '/register' + location.search,
					name: 'Register',
				},
			},
		};
	};

	render() {
		const { location } = this.props;
		const query = qs.parse(location.search, { ignoreQueryPrefix: true });

		return (
			<div className={wrapperStyle}>
				<Helmet title="Login" />

				<section className={innerWrapperStyle}>
					<h1 className={titleStyle}>Welcome back!</h1>
					<h3>Trying to log in to an eLearning course?</h3>
					<p>Head over to <a href="//insideoutinstitute.litmos.com/account/Login">here</a></p>
          <strong>Attention: logins are currently disabled. We are working to resolve this issue</strong>
					<LoginForm redirect={query.redirect} />
				</section>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/log-in/index.js